import DashboardWebAnalytics from "./DashboardWebAnalytics";

export default DashboardWebAnalytics;
